export default class OrientacaoListController {
  constructor($state, Group, UIService, Orientacao, OrientacaoService, Orientando, GrauAcademico, Instituicao, OrientacaoTipo, OrientacaoEstado, User, Investigador) {
    this.$state = $state;
    this.Group = Group;
    this.UI = UIService;
    this.Orientacao = Orientacao;
    this.OrientacaoService = OrientacaoService;
    this.Orientando = Orientando;
    this.GrauAcademico = GrauAcademico;
    this.Instituicao = Instituicao;
    this.OrientacaoTipo = OrientacaoTipo;
    this.OrientacaoEstado = OrientacaoEstado;
    this.User = User;
    this.Investigador = Investigador;

    this.dataLoaded = false;

    this.orientandos = [];
    this.grausAcademicos = [];
    this.instituicoes = [];
    this.orientacoesTipo = [];
    this.users = [];
    this.estados = [];
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.investigadores = [];
    this.filtersLoaded = [0, 0, 0, 0, 0, 0, 1, 0];

    this.opt = $state.params;

    this.displayColumns = [
      { displayName: 'ID SGI', name: 'id', visible: false, sortable: true },
      { displayName: 'Orientando', name: 'orientando', visible: true, sortable: true },
      { displayName: 'Designação como Autor', name: 'nomeAutor', visible: false, sortable: true },
      { displayName: 'Título do Trabalho', name: 'titulo', visible: true, sortable: true },
      { displayName: 'Grau Académico', name: 'grauAcademico', visible: false, sortable: true },
      { displayName: 'Aluno Internacional', name: 'international', visible: false, sortable: true },
      { displayName: 'Email', name: 'email', visible: true, sortable: true },
      { displayName: 'Designação / Curso', name: 'designacao', visible: true, sortable: true },
      { displayName: 'Instituição', name: 'instituicao', visible: true, sortable: true },
      { displayName: 'Tipo de Orientação', name: 'orientacaoTipo', visible: true, sortable: true },
      { displayName: 'Data de Início', name: 'dataInicio', exportDate: 'DD-MM-YYYY', sortable: true, visible: true },
      { displayName: 'Data de Fim', name: 'dataFim', exportDate: 'DD-MM-YYYY', sortable: true, visible: true },
      { displayName: 'Estado', name: 'estado', visible: true, sortable: true },
      { displayName: 'Criado Por', name: 'criadoPor', visible: false, sortable: true },
      { displayName: 'URL', name: 'url', visible: true, sortable: true },
    ];

    // type 's': select, 'o': plain text, 'd': date
    this.equalityFilters = [{
      val: 'a',
      name: 'Igual',
      type: 'o'
    },
      {
        val: 'b',
        name: 'Diferente',
        type: 'o'
      },
      {
        val: 'c',
        name: 'Começa por',
        type: 'o'
      },
      {
        val: 'd',
        name: 'Termina com',
        type: 'o'
      },
      {
        val: 'e',
        name: 'Contém',
        type: 'o'
      },
      {
        val: 'a',
        name: 'Igual (=)',
        type: 'd'
      },
      {
        val: 'b',
        name: 'Diferente de (≠)',
        type: 'd'
      },
      {
        val: 'c',
        name: 'Posterior a (>)',
        type: 'd'
      },
      {
        val: 'd',
        name: 'Anterior a (<)',
        type: 'd'
      },
      {
        val: 'e',
        name: 'Posterior ou igual (≥)',
        type: 'd'
      },
      {
        val: 'f',
        name: 'Anterior ou igual (≤)',
        type: 'd'
      },
      {
        val: 'a',
        name: 'Igual',
        type: 's'
      },
      {
        val: 'b',
        name: 'Diferente',
        type: 's'
      }
    ];

    this.dateFilters = this.equalityFilters.filter(x => x.type === 'd');

    this.columns = [{
      id: 'Orientacao.id',
      name: 'ID SGI',
      type: 'o'
    },
      {
        id: 'Orientacao.orientandoId',
        name: 'Orientando',
        type: 's',
        list: this.orientandos
      },
      {
        id: 'OrientacaoInvestigador.investigadorId',
        name: 'Orientador ISR',
        type: 's',
        list: this.investigadores
      },
      {
        id: 'Orientando.nomeAutor',
        name: 'Designação como Autor',
        type: 'o'
      },
      {
        id: 'OrientacaoInvestigador.orientador',
        name: 'Orientador Externo',
        type: 'o'
      },
      {
        id: 'Orientacao.titulo',
        name: 'Título do Trabalho',
        type: 'o'
      },
      {
        id: 'Orientacao.grauId',
        name: 'Grau Académico',
        type: 's',
        list: this.grausAcademicos
      },
      {
        id: 'Orientando.international',
        name: 'Aluno Internacional',
        type: 's',
        list: this.simnao
      },
      {
        id: 'Orientando.email',
        name: 'Email',
        type: 'o'
      },
      {
        id: 'Orientacao.designacao',
        name: 'Designação / Curso',
        type: 'o'
      },
      {
        id: 'Orientacao.instituicaoId',
        name: 'Instituição',
        type: 's',
        list: this.instituicoes
      },
      {
        id: 'Orientacao.orientacaoTipoId',
        name: 'Tipo de Orientação',
        type: 's',
        list: this.orientacoesTipo
      },
      {
        id: 'Orientacao.dataInicio',
        name: 'Data de Início',
        type: 'd',
        format: "YYYY-MM-DD",
        displayFormat: "DD/MM/YYYY"
      },
      {
        id: 'Orientacao.dataFim',
        name: 'Data de Fim',
        type: 'd',
        format: "YYYY-MM-DD",
        displayFormat: "DD/MM/YYYY"
      },
      {
        id: 'Orientacao.estadoId',
        name: 'Estado',
        type: 's',
        list: this.estados
      },
      {
        id: 'Orientacao.criadoPorId',
        name: 'Criado por',
        type: 's',
        list: this.users
      },
      {
        id: 'Orientacao.url',
        name: 'URL',
        type: 'o',
      }
    ];


    // Find relevant displayColumns from local storage
    if (localStorage.getItem('ISR_SGI_DisplayColumns')) {
      let displayColumns = JSON.parse(localStorage.getItem('ISR_SGI_DisplayColumns'));
      if (displayColumns && displayColumns.orientacao && displayColumns.orientacao.length > 0) {
        displayColumns.orientacao.forEach(c => {
          let i = this.displayColumns.findIndex(x => x.name === c.name);
          if (i >= 0) this.displayColumns[i].visible = c.visible;
        });
      }
    }

    this.customFilters = [];

    // Find customFilters from local storage
    if (localStorage.getItem('ISR_SGI_Filters')) {
      let storageFilters = JSON.parse(localStorage.getItem('ISR_SGI_Filters'));
      if (storageFilters.orientacao) this.customFilters = storageFilters.orientacao;
    }

    // Check if something comes from the URL, replace the customFilters if so
    if (this.opt.filter) {
      this.customFilters = [];
      let filters = this.opt.filter.split(":");
      filters.forEach(filter => {
        let a = filter.split("·");
        if (a.length === 3) {
          try {
            let data = {
              column: {},
              value: {}
            };
            data.column.selected = this.columns.find(f => {
              return f.id === a[0];
            });
            if (angular.isUndefined(data.column.selected)) {
              throw Error();
            }
            this.customFilters.push(data);
          } catch (e) {
            this.customFilters = [];
            this.UI.addToast('Não foi possível carregar filtros');
          }
        }
      });
      // If updated, save it to local storage
      this.setToLocalStorage('ISR_SGI_Filters', 'orientacao', this.customFilters);
    }

    // Restore list to selected if exists
    this.customFilters.forEach(f => {
      if (f.column && f.column.selected) {
        if (f.column && f.column.selected) {
          if (f.column.selected.id === 'Orientacao.orientandoId')
            f.column.selected.list = this.orientandos;
          if (f.column.selected.id === 'OrientacaoInvestigador.investigadorId')
            f.column.selected.list = this.investigadores;
          if (f.column.selected.id === 'Orientacao.grauId')
            f.column.selected.list = this.grausAcademicos;
          if (f.column.selected.id === 'Orientando.international')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Orientacao.instituicaoId')
            f.column.selected.list = this.instituicoes;
          if (f.column.selected.id === 'Orientacao.orientacaoTipoId')
            f.column.selected.list = this.orientacoesTipo;
          if (f.column.selected.id === 'Orientacao.estadoId')
            f.column.selected.list = this.estados;
          if (f.column.selected.id === 'Orientacao.criadoPorId')
            f.column.selected.list = this.users;
        }
      }
      // Fix date filters to be moment()
      if (f.column.selected.type === 'd') {
        f.value = moment(f.value).utc();
        f.value.second(0); // We don't care about seconds
      }
    });

    // Number of selected items
    this.nSelected = 0;
    this.everythingSelected = false;

    // Load the data for the filter panel (not mandatory just to look at the table)
    this.loadData();
    // Load the table data so we can see stuff even if nothing else works
    this.getOrientacoes();
  }

  // Set to localStorage storageKey, to the value with the content for that value
  setToLocalStorage = (storageKey, value, content) => {
    let s = JSON.parse(localStorage.getItem(storageKey));
    if (s) { // If storageKey exists, check if value exists
      if (s[value]) {
        if (content) {
          s[value] = content;
        } else {
          delete s[value];
        }
      } else {
        if (content) {
          s[value] = content;
        } else {
          // Nothing...
        }
      }
    } else {
      if (content) {
        s = {};
        s[value] = content;
      } else {
        // Nothing...
      }
    }
    localStorage.setItem(storageKey, JSON.stringify(s));
  };



  // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
  setWhereField = (data, whereObject, whereOrObject) => {
    // Check if have this entry in whereOr already
    if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
      whereOrObject.push({
        key: data.key,
        value: data.value
      });
    } else { // Not in OR, check if there's an entry of this key in whereObject already
      if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
        whereOrObject.push({
          key: data.key,
          value: whereObject[data.key]
        });
        delete whereObject[data.key];
        whereOrObject.push({
          key: data.key,
          value: data.value
        });
      } else { // It's the first entry of this key, use whereObject only
        whereObject[data.key] = data.value;
      }
    }
  };

  // Returns a whereFields object to use in table() remote methods
  // WhereLiteral should be defined locally
  setWhereFields = (customFilters, literal, orsLiteral) => {
    let where = {};
    let whereDates = [];
    let whereNextDates = [];
    let whereLiteral = literal || {};
    let whereOrLiteral = orsLiteral || [];
    let whereOr = [];

    customFilters.forEach(f => {
      let data = {};
      data.key = f.column.selected.id;
      // Generated dates - Assuming if no . exists in field, it's always generated date
      if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
        whereNextDates.push({
          key: data.key,
          comp: f.values.selected.val,
          value: f.value,
          format: f.column.selected.format
        });
      } else { // All other cases where fields exist in database
        if (f.column.selected.type === 'o') {
          data.value = f.value;

          this.setWhereField(data, where, whereOr);
        } else {
          if (f.column.selected.type === 'd') {
            whereDates.push({
              key: data.key,
              comp: f.values.selected.val,
              value: f.value,
              format: f.column.selected.format
            });
          } else {
            // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
            if (f.value.selected.id)
              data.value = f.value.selected.id;
            else
              data.value = f.value.selected.value;

            this.setWhereField(data, whereLiteral, whereOrLiteral);
          }
        }
      }
    });
    return {
      where: where,
      whereDates: whereDates,
      whereNextDates: whereNextDates,
      whereLiteral: whereLiteral,
      whereOr: whereOr,
      whereOrLiteral: whereOrLiteral
    };
  };

  clearFilter = () => {
    this.setToLocalStorage('ISR_SGI_Filters', 'orientacao', null);
    this.customFilters = [];
    this.getOrientacoes();
  };

  getOrientacoes = () => {
    this.tableLoading = true;

    let whereFields = this.setWhereFields(this.customFilters);

    this.Orientacao.table({
      params: {
        fields: [ // edit exportOrientacoes() too
          'Orientacao.id as id',
          'Orientacao.titulo as titulo',
          'Orientacao.designacao as designacao',
          'Orientacao.dataInicio as dataInicio',
          'Orientacao.dataFim as dataFim',
          'Orientacao.criadoPorId as criadoPorId',
          'Orientacao.url as url',
          'Orientando.nome as orientando',
          'Orientando.nomeAutor as nomeAutor',
          'Orientando.email as email',
          'Orientando.international as international',
          'GrauAcademico.sigla as grauAcademico',
          'Instituicao.designacao as instituicao',
          'OrientacaoTipo.designacao as orientacaoTipo',
          'OrientacaoEstado.designacao as estado',
          'User.name as criadoPor'
        ],
        from: ['Orientacao', 'Orientando', 'GrauAcademico', 'Instituicao', 'OrientacaoTipo', 'OrientacaoEstado', 'User', 'OrientacaoInvestigador'],
        referencesOrigin: [undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'OrientacaoInvestigador.orientacaoId'],
        references: [undefined, 'Orientacao.orientandoId', 'Orientacao.grauId', 'Orientacao.instituicaoId', 'Orientacao.orientacaoTipoId', 'Orientacao.estadoId', 'Orientacao.criadoPorId', 'Orientacao.id'],
        aliases: [],
        where: whereFields.where,
        whereLiteral: whereFields.whereLiteral,
        whereDates: whereFields.whereDates,
        whereOr: whereFields.whereOr,
        whereOrLiteral: whereFields.whereOrLiteral,
        groupBy: ['Orientacao.id'], // Do groupBy when having N:M relation
        order: this.opt.order,
        sort: this.opt.sort,
        limit: this.opt.items,
        skip: (this.opt.page - 1) * this.opt.items,
      }
    }).$promise.then(res => {
      let page = this.opt.page;
      let items = this.opt.items;

      let total = res.count;

      this.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.start - 1 + items) >= total) {
        this.end = total;
      } else {
        this.end = Number.parseInt(this.start - 1 + items);
      }

      // Process output
      // res.data.forEach(i => {
      //
      // });

      this.orientacoes = res.data;
      this.total = total;
      this.tableLoading = false;
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Erro na busca de orientações. Verifique a ligação");
    });
  };

  isColumnVisible = (column) => {
    let f = this.displayColumns.find(x => x.name === column);
    return _.isEmpty(f) ? false : f.visible;
  };

  selectVisibleColumns = () => {
    let options = {
      size: 'md',
      template: require('./columns.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.title = "Editar Campos Visíveis";
        scope.displayColumns = angular.copy(this.displayColumns);

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };

    let modal = this.UI.showDialog(options);

    modal.then((res) => {
      if (res && res.displayColumns) {
        this.displayColumns = angular.copy(res.displayColumns);
        // Save it to local storage
        this.setToLocalStorage('ISR_SGI_DisplayColumns', 'orientacao', this.displayColumns);
      }
    });
  };

  loadData = () => {
    this.Orientando.find({
    }).$promise.then(orientandos => {
      orientandos.forEach(t => {
        t.name = t.nome;
      });
      this.orientandos = orientandos;
      this.filtersLoaded[0] = 1;
    }).catch(e => {
      this.orientandos = [];
      this.filtersLoaded[0] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Orientandos).");
    });

    this.GrauAcademico.find({
    }).$promise.then(grausAcademicos => {
      grausAcademicos.forEach(t => {
        t.name = t.sigla;
      });
      this.grausAcademicos = grausAcademicos;
      this.filtersLoaded[1] = 1;
    }).catch(e => {
      this.grausAcademicos = [];
      this.filtersLoaded[1] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Graus Académicos).");
    });

    this.Instituicao.find({
    }).$promise.then(instituicoes => {
      instituicoes.forEach(t => {
        t.name = t.designacao;
      });
      this.instituicoes = instituicoes;
      this.filtersLoaded[2] = 1;
    }).catch(e => {
      this.instituicoes = [];
      this.filtersLoaded[2] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Instituições).");
    });

    this.OrientacaoTipo.find({
    }).$promise.then(orientacoesTipo => {
      orientacoesTipo.forEach(t => {
        t.name = t.designacao;
      });
      this.orientacoesTipo = orientacoesTipo;
      this.filtersLoaded[3] = 1;
    }).catch(e => {
      this.orientacoesTipo = [];
      this.filtersLoaded[3] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Tipos de Orientação).");
    });

    this.OrientacaoEstado.find({
    }).$promise.then(estados => {
      estados.forEach(t => {
        t.name = t.designacao;
      });
      this.estados = estados;
      this.filtersLoaded[4] = 1;
    }).catch(e => {
      this.estados = [];
      this.filtersLoaded[4] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Estados de Orientação).");
    });

    this.User.find({
      filter: {
        where: {
          email: {like: '%isr.uc.pt'} // Only show @ISR users
        }
      }
    }).$promise.then(users => {
      // users.forEach(t => {
      //   t.name = t.designacao;
      // });
      this.users = users;
      this.filtersLoaded[5] = 1;
    }).catch(e => {
      this.users = [];
      this.filtersLoaded[5] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Utilizadores).");
    });

    this.Investigador.find({
    }).$promise.then(investigadores => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      investigadores.forEach(t => {
        t.name = t.nome;
      });
      this.investigadores = investigadores;
      this.filtersLoaded[7] = 1;
    }).catch(e => {
      this.investigadores = [];
      this.filtersLoaded[7] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Investigadores).");
    });

  };

  sort = key => {
    if (!key.sortable) {
      return;
    }
    let keyname = key.name;
    if (this.opt.order === keyname)
      this.opt.page = 1;
    this.opt.order = keyname;
    this.opt.sort = this.opt.sort === 'asc' ? 'desc' : 'asc';
    this.$state.go('app.orientacao.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getOrientacoes();
  };

  item = val => {
    this.opt.items = val;
    this.$state.go('app.orientacao.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getOrientacoes();
  };

  page = sum => {
    this.opt.page += sum;
    if (this.opt.page < 1)
      this.opt.page = 1;
    if (this.opt.page > Math.ceil(this.total / this.opt.items))
      this.opt.page = Math.ceil(this.total / this.opt.items);
    this.$state.go('app.orientacao.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getOrientacoes();
  };

  openFilter = () => {
    let result = this.filtersLoaded.reduce((a, b) => a + b, 0);

    if (result !== this.filtersLoaded.length) {
      this.UI.addToast("A carregar dados para filtragem, por favor tente novamente");
      return;
    }

    if (!this.orientandos.length && !this.grausAcademicos.length && !this.instituicoes.length && !this.orientacoesTipo.length && !this.users.length) {
      this.UI.addToast("Erro ao carregar dados de filtragem. Por favor recarregue a página.");
      return;
    }

    this.columns.forEach(f => {
      if (f.id === 'Orientacao.orientacaoId')
        f.list = this.orientandos;
      if (f.id === 'OrientacaoInvestigador.investigadorId')
        f.list = this.investigadores;
      if (f.id === 'Orientacao.grauId')
        f.list = this.grausAcademicos;
      if (f.id === 'Orientando.international')
        f.list = this.simnao;
      if (f.id === 'Orientacao.instituicaoId')
        f.list = this.instituicoes;
      if (f.id === 'Orientacao.orientacaoTipoId')
        f.list = this.orientacoesTipo;
      if (f.id === 'Orientacao.estadoId')
        f.list = this.estados;
      if (f.id === 'Orientacao.criadoPorId')
        f.list = this.users;
    });

    // Copy column to be used in
    this.editColumns = angular.copy(this.columns);

    // Restore list to selected
    this.customFilters.forEach(f => {
      if (f.column && f.column.selected) {
        if (f.column.selected.id === 'Orientacao.orientacaoId')
          f.column.selected.list = this.orientandos;
        if (f.column.selected.id === 'OrientacaoInvestigador.investigadorId')
          f.column.selected.list = this.investigadores;
        if (f.column.selected.id === 'Orientacao.grauId')
          f.column.selected.list = this.grausAcademicos;
        if (f.column.selected.id === 'Orientando.international')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Orientacao.instituicaoId')
          f.column.selected.list = this.instituicoes;
        if (f.column.selected.id === 'Orientacao.orientacaoTipoId')
          f.column.selected.list = this.orientacoesTipo;
        if (f.column.selected.id === 'Orientacao.estadoId')
          f.column.selected.list = this.estados;
        if (f.column.selected.id === 'Orientacao.criadoPorId')
          f.column.selected.list = this.users;
      }
    });
    // Copy customFilter to another variable so we can edit it all we want
    this.editCustomFilters = angular.copy(this.customFilters);
    // Show side panel
    this.fs = true;
  };

  oldColumn = ($item, i) => {
    //Infinite Scroll Magic
    i.infiniteScroll = {};
    i.infiniteScroll.numToAdd = 20;
    i.infiniteScroll.currentItems = 20;

    if ($item.type === 's')
      i.value = {};
    else
      i.value = "";

    i.addMoreItems = function () {
      i.infiniteScroll.currentItems += i.infiniteScroll.numToAdd;
    };
  };

  applyFilter = () => {
    // Parse values from sidebar
    this.editCustomFilters = _.filter(this.editCustomFilters, f => f.column && !_.isEmpty(f.value));

    // Remove list for column, no need to save it
    this.editCustomFilters.forEach(f => {
      if (f.column && f.column.selected) {
        f.column.selected.list = [];
      }
      // Fix date filters to be moment()
      if (f.column.selected.type === 'd') {
        f.value = moment(f.value).utc();
        f.value.second(0); // We don't care about seconds
      }
    });

    this.customFilters = angular.copy(this.editCustomFilters);

    this.setToLocalStorage('ISR_SGI_Filters', 'orientacao', this.customFilters);
    this.fs = false;
    // Go to first page for results
    this.opt.page = 1;
    this.$state.go('app.orientacao.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });

    this.getOrientacoes();
  };

  hasSelect = () => {
    return _.some(this.orientacoes, a => a.selected === true);
  };

  selectAll = () => {
    if (this.allSelected) { // Not all are selected, select all
      this.orientacoes.forEach(a => {
        a.selected = true;
      });
      this.nSelected = this.orientacoes.length;
    } else { // Remove all selections
      this.orientacoes.forEach(a => {
        a.selected = false;
      });
      this.nSelected = 0;
    }
    this.everythingSelected = false;
  };

  selectEverything = (type) => {
    if (!type) {
      this.orientacoes.forEach(a => {
        a.selected = false;
      });
      this.nSelected = 0;
      this.allSelected = false;
    }
    this.everythingSelected = !!type;
  };

  selectItem = () => {
    this.nSelected = _.filter(this.orientacoes, r => r.selected).length;
    this.allSelected = this.nSelected >= this.orientacoes.length;
    this.everythingSelected = false;
  };

  deleteOrientacao = (orientacao) => {
    this.OrientacaoService.confirmDeleteOrientacao(orientacao).then(() => {
      this.getOrientacoes();
    }).catch(error => {
      console.log(error);
      this.getOrientacoes();
    });
  };
}

OrientacaoListController.$inject = ['$state', 'Group', 'UIService', 'Orientacao', 'OrientacaoService', 'Orientando', 'GrauAcademico', 'Instituicao', 'OrientacaoTipo', 'OrientacaoEstado', 'User', 'Investigador'];
